import React from 'react';
import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const ScoringCategoryDetailItemComponent = ({ scoringCategoryDetail, dispatch, index, scaleFormat, visibleNumeric, validation }) => {
  const { t } = useTranslation();
  const onPropertyChanged = (detailPropertyName, detailPropertyValue) => {
    dispatch({ type: 'OnDetailsPropertyChanged', detailPropertyName, detailPropertyValue, index });
  };

  return (
    <>
      <Prompt when={scoringCategoryDetail.changed} message={t('ScoringCategories.LeavingWithoutSavingDetail', { index: index + 1 })} />
      <Grid container item spacing={2}>
        <Grid item xs={12} sm={2}>
          <TextField
            isNumeric
            fullWidth
            value={scoringCategoryDetail.orderNo}
            decimalScale={0}
            onChange={event => onPropertyChanged('orderNo', event)}
            label={t('ScoringCategories.Details.OrderNo')}
            error={!isValid(validation.orderNo)}
            helperText={getErrors(validation.orderNo)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            value={scoringCategoryDetail.code || ''}
            onChange={event => onPropertyChanged('code', event)}
            label={t('ScoringCategories.Details.Code')}
            error={!isValid(validation.code)}
            helperText={getErrors(validation.code)}
          />
        </Grid>
        <Grid item xs={12} sm={3} lg={4}>
          <TextField
            fullWidth
            value={scoringCategoryDetail.scoringDetailName || ''}
            onChange={event => onPropertyChanged('scoringDetailName', event)}
            label={t('ScoringCategories.Details.ScoringDetailName')}
            error={!isValid(validation.scoringDetailName)}
            helperText={getErrors(validation.scoringDetailName)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            isNumeric
            fullWidth
            value={scoringCategoryDetail.score}
            inputProps={{ decimalScale: scaleFormat }}
            onChange={event => onPropertyChanged('score', event)}
            label={t('ScoringCategories.Details.Score')}
            error={!isValid(validation.score)}
            helperText={getErrors(validation.score)}
          />
        </Grid>
        <Grid item xs={12} sm={3} lg={2}>
          <FormControlLabel
            control={<Checkbox checked={scoringCategoryDetail.defaultYN || false} color='primary' />}
            onChange={event => onPropertyChanged('defaultYN', event.target.checked)}
            label={t('ScoringCategories.Details.Default')}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            value={scoringCategoryDetail.description || ''}
            onChange={event => onPropertyChanged('description', event)}
            label={t('ScoringCategories.Details.Description')}
          />
        </Grid>
        {visibleNumeric === 2 && (
          <>
            <Grid item xs={12} sm={2}>
              <TextField
                isNumeric
                fullWidth
                value={scoringCategoryDetail.minValue}
                inputProps={{ decimalScale: scaleFormat }}
                onChange={event => onPropertyChanged('minValue', event)}
                label={t('ScoringCategories.Details.MinValue')}
                error={!isValid(validation.minValue)}
                helperText={getErrors(validation.minValue)}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                isNumeric
                fullWidth
                value={scoringCategoryDetail.maxValue}
                inputProps={{ decimalScale: scaleFormat }}
                onChange={event => onPropertyChanged('maxValue', event)}
                label={t('ScoringCategories.Details.MaxValue')}
                error={!isValid(validation.maxValue)}
                helperText={getErrors(validation.maxValue)}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

ScoringCategoryDetailItemComponent.propTypes = {
  scoringCategoryDetail: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  visibleNumeric: PropTypes.number,
  scaleFormat: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default ScoringCategoryDetailItemComponent;
